import { toast } from 'react-toastify';
import { auth } from '../firebase';

export const showSuccessToast = (message) => {
    toast.success(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

export const showErrorToast = (message) => {
    toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

export const showInfoToast = (message) => {
    toast.info(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

// Create a component for the login toast to use hooks
const LoginToastContent = ({ message }) => {
    const handleClick = async () => {
        try {
            // Sign out from Firebase
            await auth.signOut();
            // Clear any existing auth state
            localStorage.removeItem('firebase:authUser');
            // Force a hard navigation to login page
            window.location.href = '/login';
        } catch (error) {
            // Remove console.error('Error signing out:', error);
        }
    };
    
    return (
        <div>
            {message}
            <button 
                onClick={handleClick}
                style={{
                    marginLeft: '10px',
                    padding: '5px 10px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                }}
            >
                Log In
            </button>
        </div>
    );
};

export const showLoginToast = (message) => {
    toast.error(
        <LoginToastContent message={message} />,
        {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    );
}; 